import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $, nothing as w } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { classMap as o } from '../../../../node_modules/lit-html/directives/class-map.js';
import '../buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import img from '../../../../assets/images/chevron-right.svg.js';
import css_248z from './sub-nav-item.scss.js';

class SubNavItem extends s {
    constructor() {
        super(...arguments);
        this.rtl = false;
        this.isActive = false;
        this.ariaLabel = '';
        this.isNoFollow = false;
        this.target = '';
    }
    handleKeyDown(e) {
        if (['Enter', ' '].includes(e.key)) {
            e.preventDefault();
            e.target.click();
        }
    }
    render() {
        const isLink = Boolean(this.url && this.url !== '#');
        const relAttr = this.isNoFollow ? 'nofollow' : 'follow';
        // Extract inner template to avoid nested template literals
        const innerTemplate = isLink
            ? $ `<a class="sub-nav-link" href="${this.url}" @keydown="${this.handleKeyDown}" tabindex="0" title="${this.title}" aria-label="${this.ariaLabel || w}" target="${this.target || w}" rel="${relAttr}"><span class="link-text body-small--regular">${this.title}</span> <img src="${img}" alt="" class="arrow-icon"></a>`
            : $ `<span class="sub-nav-link" title="${this.title}" aria-label="${this.ariaLabel || w}"><span class="link-text body-small--regular">${this.title}</span> <img src="${img}" alt="" class="arrow-icon"></span>`;
        return $ `<div class="${o({
            'sub-nav-container': true,
            rtl: this.rtl || isRTL(),
            active: this.isActive,
        })}">${innerTemplate}</div>`;
    }
}
SubNavItem.styles = css_248z;
__decorate([
    e({ type: String })
], SubNavItem.prototype, "title", void 0);
__decorate([
    e({ type: Boolean })
], SubNavItem.prototype, "rtl", void 0);
__decorate([
    e({ type: String })
], SubNavItem.prototype, "url", void 0);
__decorate([
    e({ type: Boolean })
], SubNavItem.prototype, "isActive", void 0);
__decorate([
    e()
], SubNavItem.prototype, "ariaLabel", void 0);
__decorate([
    e({ type: Boolean, reflect: true })
], SubNavItem.prototype, "isNoFollow", void 0);
__decorate([
    e({ type: String, reflect: true })
], SubNavItem.prototype, "target", void 0);
customElements.define('sub-nav-item', SubNavItem);

export { SubNavItem };
